import { normalizePhone } from "./crm-config";
import { toLatinDigits } from "./ownership-config";

// Client-side list search shared by the admin pages: what staff type (Persian keyboard,
// copied Persian-digit phones, «0912 345 6789», Arabic ي/ك, lower-case VIN) must still match.

/** Comparable form of free text: Latin digits, Persian ی/ک, no ZWNJ, single spaces, lower case */
export const searchKey = (value: string) =>
  toLatinDigits(value)
    .replace(/[يى]/g, "ی")
    .replace(/ك/g, "ک")
    .replace(/[‌‎‏]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

const PHONE_LIKE = /^[+\d\s()-]+$/;
const compact = (value: string) => value.replace(/[\s()-]/g, "");

/** Whether any field contains the term; an empty term matches everything */
export const matchesSearch = (term: string, fields: readonly (string | null | undefined)[]) => {
  const key = searchKey(term);
  if (key === "") return true;
  const keys = fields.map((field) => searchKey(field ?? ""));
  if (keys.some((field) => field.includes(key))) return true;
  const digits = phoneDigits(key);
  return digits !== "" && keys.some((field) => compact(field).includes(digits));
};

/**
 * «0912 345-6789» or «+98 912…» is looked up as the digits of a stored 09123456789 (or a
 * dashed order number) with spaces, brackets and dashes removed; "" for a non-phone key
 */
export const phoneDigits = (key: string) => (PHONE_LIKE.test(key) ? normalizePhone(key) : "");
